// All orders related apis
import instance from './api';

import { API_URL } from './api';
import { encryptData } from '../helpers/encryptDecrypt';

// Get api for fetching the organization of the active user (also fetches the branches related to that organization and the requesting user)
export const fetchOrganizations = async () => {
  return await instance.get(`${API_URL}/organizations`);
};

// Get api for fetching organization with ID (not in use)
export const fetchOrganizationById = async (organizationId) => {
  const oId = encryptData(organizationId);
  return await instance.get(`${API_URL}/organizations/${oId}/organization`);
};

// Get api for fetching branches for active organization
export const fetchBranchesByOrganization = async (organizationId) => {
  const oId = encryptData(organizationId);
  return await instance.get(`${API_URL}/organizations/${oId}/branches`);
};

// Post api for changing the currency of the organizaiton
export const changeOrganizationCurrency = async (organizationId, data) => {
  const oId = encryptData(organizationId);
  return await instance.post(`${API_URL}/organizations/${oId}/change-currency`, data);
};

// Post api for creating a new organization for the active user
export const addOrganization = async (organizationData) => {
  return await instance.post(`${API_URL}/organizations`, organizationData);
}

// Post api for updating the existing organization's details
export const updateOrganization = async (organizationData, organizationId) => {
  const oId = encryptData(organizationId);
  return await instance.post(`${API_URL}/organizations/${oId}`, organizationData);
}

// Get api for fetching activity logs for the active organization and branch
export const fetchActivityLogs = async (organizationId, branchId) => {
  const oId = encryptData(organizationId);
  const bId = encryptData(branchId);
  return await instance.get(`${API_URL}/activities/${oId}/${bId}`);
}


